import { VisuallyHidden } from "@radix-ui/react-visually-hidden"
import classNames from "classnames"
import React from "react"
import { Drawer } from "vaul"

import Video from "../elements/V2/Video"

type Props = {
  videoUrl: string
  coverImage: string
  imageAlt: string
  title: string
  aspectRatio?: "1:1" | "16:9" | "9:16" | "3:4" | "4:3" | "fullWidth"
}

// Note - This requires an accompanying Drawer.Root as a parent component
const VideoModal = ({
  videoUrl,
  coverImage,
  imageAlt,
  title,
  aspectRatio = "16:9",
}: Props) => {
  return (
    <Drawer.Portal>
      <Drawer.Overlay className="fixed -top-28 bottom-0 left-0 right-0 z-50 bg-black/30" />
      <VisuallyHidden>
        <Drawer.Title>Video Modal</Drawer.Title>
        <Drawer.Description>
          Modal displaying a video about {title}
        </Drawer.Description>
      </VisuallyHidden>
      <Drawer.Content className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div
          className={classNames(
            "relative z-[100] w-full bg-charcoal px-24 pb-12 pt-24 sm:px-12 sm:pb-16 sm:pt-12",
            aspectRatio === "9:16" || aspectRatio === "3:4"
              ? "max-w-[70vw] sm:max-w-[50vw] md:max-w-[35vw] lg:max-w-[30vw]"
              : "max-w-[90vw] sm:max-w-[80vw] md:max-w-[75vw] lg:max-w-[70vw]"
          )}
        >
          <Video
            video={videoUrl}
            coverImage={coverImage}
            ImageAlt={imageAlt}
            aspectRatio={aspectRatio}
            playbackMode="manual"
            playOnMobile
          />
          <div className="mx-auto mt-8 h-[2px] w-40 shrink-0 bg-white/20 sm:mt-12" />
        </div>
        <Drawer.Close className="fixed inset-0" />
      </Drawer.Content>
    </Drawer.Portal>
  )
}

export default VideoModal
